import { buildVueDompurifyHTMLDirective } from 'vue-dompurify-html'

// Export of the Layout components
import Base from './layout/Base'

// Export of components
import Input from './components/Input'
import Autocomplete from './components/Autocomplete'
import Select from './components/Select'
import Button from './components/Button'
import Checkbox from './components/Checkbox'
import Radio from './components/Radio'
import Quantitybutton from './components/Quantitybutton'
import Infotooltip from './components/Infotooltip'
import Alert from './components/Alert'
import Icon from './components/Icon'
import Card from './components/Card'
import Divider from './components/Divider'
import ExpansionPanel from './components/ExpansionPanel'
import Toast from './components/Toast'
import Spinner from './components/Spinner'
import Intro from './components/Intro'
import Media from './components/Media'
import Step from './components/Step'
import StepWrapper from './components/StepWrapper'
import Closing from './components/Closing'
import BaseComponentTemplate from './components/BaseComponentTemplate'
import GridTemplate from './components/GridTemplate'
import DownloadButton from './components/DownloadButton'
import CollapseItem from './components/CollapseItem'
import CollapseWrapper from './components/CollapseWrapper'
import ScrollSnapSlider from './components/ScrollSnapSlider'
import Modal from './components/Modal'
import SignatureInput from './components/SignatureInput'

// Import of the organisms (komplexe Komponenten)
import Hero from './organisms/Hero'
import SectionText from './organisms/SectionText'
import SectionImageText from './organisms/SectionImageText'
import BaseSectionTemplate from './organisms/BaseSectionTemplate'
import { Plugin } from 'vue'

// Export of the JS-Classes
export { default as Tracking } from './classes/Tracking'

export default {
  install(app) {
    app.directive('clean-html', buildVueDompurifyHTMLDirective())

    app.component('PflegeBase', Base)
    app.component('PflegeInput', Input)
    app.component('PflegeAutocomplete', Autocomplete)
    app.component('PflegeSelect', Select)
    app.component('PflegeButton', Button)
    app.component('PflegeCheckbox', Checkbox)
    app.component('PflegeRadio', Radio)
    app.component('PflegeQuantitybutton', Quantitybutton)
    app.component('PflegeInfotooltip', Infotooltip)
    app.component('PflegeAlert', Alert)
    app.component('PflegeIcon', Icon)
    app.component('PflegeCard', Card)
    app.component('PflegeDivider', Divider)
    app.component('PflegeExpansionPanel', ExpansionPanel)
    app.component('PflegeToast', Toast)
    app.component('PflegeSpinner', Spinner)
    app.component('PflegeIntro', Intro)
    app.component('PflegeMedia', Media)
    app.component('PflegeStep', Step)
    app.component('PflegeStepWrapper', StepWrapper)
    app.component('PflegeClosing', Closing)
    app.component('PflegeBaseComponentTemplate', BaseComponentTemplate)
    app.component('PflegeGridTemplate', GridTemplate)
    app.component('PflegeDownloadButton', DownloadButton)
    app.component('PflegeCollapseItem', CollapseItem)
    app.component('PflegeCollapseWrapper', CollapseWrapper)
    app.component('PflegeScrollSnapSlider', ScrollSnapSlider)
    app.component('PflegeModal', Modal)
    app.component('PflegeSignatureInput', SignatureInput)
    
    app.component('PflegeHero', Hero)
    app.component('PflegeSectionText', SectionText)
    app.component('PflegeSectionImageText', SectionImageText)
    app.component('PflegeBaseSectionTemplate', BaseSectionTemplate)

    app.config.globalProperties.$sharedComponentsInitialized = true
  },
} satisfies Plugin

export {
  Base as PflegeBase,
  Input as PflegeInput,
  Autocomplete as PflegeAutocomplete,
  Select as PflegeSelect,
  Button as PflegeButton,
  Checkbox as PflegeCheckbox,
  Radio as PflegeRadio,
  Quantitybutton as PflegeQuantitybutton,
  Infotooltip as PflegeInfotooltip,
  Alert as PflegeAlert,
  Icon as PflegeIcon,
  Card as PflegeCard,
  Divider as PflegeDivider,
  ExpansionPanel as PflegeExpansionPanel,
  Toast as PflegeToast,
  Spinner as PflegeSpinner,
  Intro as PflegeIntro,
  Media as PflegeMedia,
  Step as PflegeStep,
  StepWrapper as PflegeStepWrapper,
  Closing as PflegeClosing,
  BaseComponentTemplate as PflegeBaseComponentTemplate,
  GridTemplate as PflegeGridTemplate,
  DownloadButton as PflegeDownloadButton,
  CollapseItem as PflegeCollapseItem,
  CollapseWrapper as PflegeCollapseWrapper,
  ScrollSnapSlider as PflegeScrollSnapSlider,
  Modal as PflegeModal,
  SignatureInput as PflegeSignatureInput,

  Hero as PflegeHero,
  SectionText as PflegeSectionText,
  SectionImageText as PflegeSectionImageText,
  BaseSectionTemplate as PflegeBaseSectionTemplate,
}

export type * from '../types'
export type * from './components/Step'
